import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./Portfolio.css";
import Portfolio from "./Portfolio.js";
import Keysprint from "./Keysprint.js";

function App() {
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Portfolio />} />
					<Route path="/keysprint" element={<Keysprint />} />
				</Routes>
			</BrowserRouter>
		</>
	);
}

export default App;
